import { Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { Button } from 'src/components';
import { TermsAndPrivacy } from 'src/auth/components/TermsAndPrivacy';

export default function SignupTabContent() {
  return (
    <>
      <Text c={'gray.10'} fw={FONT_WEIGHTS.bold} size={'lg'} mt={'xl'} mb={'xs'}>
        Start your free trial
      </Text>

      <Text c={'gray.10'} fw={FONT_WEIGHTS.medium} size={'sm'} mb={'xl'}>
        Get full access to Afternoon. Share a few details about your firm and we’ll set up a
        workspace for you.
      </Text>
      <Flex align={'center'} direction={'column'} gap={'xxs'}>
        <Button
          variant={'primary'}
          fullWidth
          to={'https://2ev5et.share-eu1.hsforms.com/2C64xbD1zQ5qFjr-PNLGIfQ'}
          target={'_blank'}
        >
          Request free trial
        </Button>
        <Button
          variant={'secondary'}
          size={'sm'}
          to={'https://share-eu1.hsforms.com/268xr8c3FQ4ux4QAKDF72Zg2ev5et'}
          target={'_blank'}
        >
          Contact our team
        </Button>
        <TermsAndPrivacy />
      </Flex>
    </>
  );
}
